<template>
  <div class="flex items-start p-3 hover:bg-gray-50 rounded">
    <div :class="['w-8 h-8 rounded-full flex items-center justify-center mr-3', getSeverityColor()]">
      <component :is="getIcon()" class="w-4 h-4 text-white" />
    </div>
    <div class="flex-1">
      <p class="text-sm font-medium">{{ alert.message }}</p>
      <p class="text-xs text-gray-500 mt-1">{{ alert.time }}</p>
    </div>
  </div>
</template>

<script setup>
import { ExclamationTriangleIcon, HeartIcon, PhoneIcon } from '@heroicons/vue/24/outline'

defineProps({
  alert: {
    type: Object,
    required: true
  }
})

function getIcon() {
  const icons = {
    medication: ExclamationTriangleIcon,
    wellness: HeartIcon,
    fall: ExclamationTriangleIcon
  }
  return icons[alert.type] || ExclamationTriangleIcon
}

function getSeverityColor() {
  const colors = {
    high: 'bg-danger-500',
    medium: 'bg-warning-500',
    critical: 'bg-danger-600'
  }
  return colors[alert.severity] || 'bg-warning-500'
}
</script>